/** The most messages one conversation's cached copy keeps. */
export const TRANSCRIPT_CACHE_LIMIT = 50;
/**
 * What of a transcript is worth caching: the settled messages, the last
 * {@link TRANSCRIPT_CACHE_LIMIT} of them, with the per-mount flags dropped.
 *
 * `resendable` is a promise THIS socket can keep — the question it marks is
 * still in this instance's transcript — and a button restored into another one
 * would resend into a conversation that may have moved on. `cached` is
 * re-applied by whoever reads the copy, so storing it says nothing.
 */
export function cacheableTail(messages) {
    return messages
        .filter((message) => message.state !== "streaming")
        .slice(-TRANSCRIPT_CACHE_LIMIT)
        .map(({ cached: _unconfirmed, resendable: _perMount, ...message }) => message);
}
//# sourceMappingURL=transcript-cache.js.map